import { Avatar, Stack, Text } from '@mantine/core';
import { useOverflowList } from 'src/design/molecules/useOverflowList';
import { DisclosurePopover } from 'src/design/molecules/DisclosurePopover';

export interface IAvatarGroupProps {
  items: IAvatarGroupItem[];
  maxItems?: number;
}

export interface IAvatarGroupItem {
  key: string;
  name: string;
  src?: string;
}

/** @registry Overlapping Mantine Avatar.Group capped at `maxItems` with a "+N" overflow avatar, revealed via a keyboard-accessible disclosure; use for compact lists of people/assignees/etc. */
export const AvatarGroup: React.FC<IAvatarGroupProps> = ({
  items,
  maxItems = 3,
}) => {
  const { visible, hidden, remaining, overflowLabel } = useOverflowList(
    items,
    maxItems,
  );

  return (
    <Avatar.Group spacing="sm">
      {visible.map((item) => (
        <Avatar
          key={item.key}
          src={item.src}
          alt={item.name}
          name={item.name}
          color="initial"
        />
      ))}
      {remaining > 0 && (
        <DisclosurePopover
          label={overflowLabel}
          content={
            <Stack gap="xs">
              {hidden.map((item) => (
                <Text key={item.key} size="sm">
                  {item.name}
                </Text>
              ))}
            </Stack>
          }
        >
          <Avatar
            component="button"
            type="button"
            style={{ cursor: 'pointer' }}
          >
            {`+${remaining}`}
          </Avatar>
        </DisclosurePopover>
      )}
    </Avatar.Group>
  );
};
